var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.99950003,2 L0,9.99150053 L16.0009999,29.9862509 L32,9.99350041 L23.9985001,2 L7.99950003,2 Z M17.9988751,3.99987501 L23.0005625,3.99987501 L26.9983126,8.0016249 L21.9986251,8.0016249 L17.9988751,3.99987501 Z M16.0009999,3.99987501 L19.9987501,8.0016249 L11.99925,8.0016249 L16.0009999,3.99987501 Z M8.99943754,3.99987501 L14.0011249,3.99987501 L9.99937504,8.0016249 L5.00168739,8.0016249 L8.99943754,3.99987501 Z M21.9986251,9.99950003 L28.9981876,9.99950003 L16.7489532,26.2484845 L21.9986251,9.99950003 Z M15.5990251,26.5904631 L11.99925,9.99950003 L19.9987501,9.99950003 L16.3989751,26.5904631 L16.0009999,26.9824386 L15.5990251,26.5904631 Z M2.99981251,9.99950003 L9.99937504,9.99950003 L15.2490469,26.2484845 L2.99981251,9.99950003 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGem);
export default __webpack_public_path__ + "static/media/Gem.0bcb903a.svg";
export { ForwardRef as ReactComponent };